import { render, staticRenderFns } from "./institutionForm.vue?vue&type=template&id=ed2ea32e&scoped=true"
import script from "./institutionForm.vue?vue&type=script&lang=js"
export * from "./institutionForm.vue?vue&type=script&lang=js"
import style0 from "./institutionForm.vue?vue&type=style&index=0&id=ed2ea32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2ea32e",
  null
  
)

export default component.exports